<div class='message' [innerHTML]='message.chatMessage'></div>
<div class='time'>
  {{ message.createdAt | date: 'HH:mm'}}
</div>

